enum ProjectChangeReason {
  NoChange = "noChange",
  ProviderExclusionsData = "providerExclusionsData",
  TemplateCollectionId = "templateCollectionId",
  TemplateCorrelationId = "templateCorrelationId",
  TemplateId = "templateId",
  MemberSetId = "memberSetId",
  MemberSetVersionId = "memberSetVersionId",
  NetworkProviderSetId = "networkProviderSetId",
  NetworkProviderSetAlias = "networkProviderSetAlias",
  NetworkProviderSetVersionId = "networkProviderSetVersionId",
  ProspectProviderSetId = "prospectProviderSetId",
  ProspectProviderSetAlias = "prospectProviderSetAlias",
  ProspectProviderSetVersionId = "prospectProviderSetVersionId",
  MarketProviderSetId = "marketProviderSetId",
  MarketProviderSetAlias = "marketProviderSetAlias",
  MarketProviderSetVersionId = "marketProviderSetVersionId",
  AccessCodeMapSetId = "accessCodeMapSetId",
  AccessCodeMapSetVersionId = "accessCodeMapSetVersionId",
  NetworkSpecialtyCodeMapSetId = "networkSpecialtyCodeMapSetId",
  NetworkSpecialtyCodeMapSetVersionId = "networkSpecialtyCodeMapSetVersionId",
  ProspectSpecialtyCodeMapSetId = "prospectSpecialtyCodeMapSetId",
  ProspectSpecialtyCodeMapSetVersionId = "prospectSpecialtyCodeMapSetVersionId",
  MarketSpecialtyCodeMapSetId = "marketSpecialtyCodeMapSetId",
  MarketSpecialtyCodeMapSetVersionId = "marketSpecialtyCodeMapSetVersionId",
  AttestationCrosswalkCodeMapSetId = "attestationCrosswalkCodeMapSetId",
  AttestationCrosswalkCodeMapSetVersionId = "attestationCrosswalkCodeMapSetVersionId",
  ServiceAreaRegionSetId = "serviceAreaRegionSetId",
  ProviderExclusionsConfig = "providerExclusionsConfig",
  ExcludedSpecialtyGroupCodes = "excludedSpecialtyGroupCodes",
  StrictTimeAndDistance = "strictTimeAndDistance",
  CountyStatusUpdate = "countyStatusUpdate",
  SpecialtyGroupNetworkProviderSetCodeMapSetId = "specialtyGroupNetworkProviderSetCodeMapSetId",
  SpecialtyGroupNetworkProviderSetCodeMapSetVersionId = "specialtyGroupNetworkProviderSetCodeMapSetVersionId",
  MemberSetId2 = "memberSetId2",
  MemberSetVersionId2 = "memberSetVersionId2",
  MemberSetAlias = "memberSetAlias",
  MemberSetAlias2 = "memberSetAlias2",
  MembershipRiskMemberSetId = "membershipRiskMemberSetId",
  MembershipRiskMemberSetVersionId = "membershipRiskMemberSetVersionId",
  MembershipRiskMemberSetAlias = "membershipRiskMemberSetAlias",
  AccuracyTemplateId = "accuracyTemplateId",
  AccuracyTemplateCollectionId = "accuracyTemplateCollectionId",
  BoundMemberships = "boundMemberships",
  TelehealthSpecialtyGroupCodes = "telehealthSpecialtyGroupCodes",
  AccuracySpecialtyToBdxCodeMapSetId = "accuracySpecialtyToBdxCodeMapSetId",
  AccuracySpecialtyToBdxCodeMapSetVersionId = "accuracySpecialtyToBdxCodeMapSetVersionId",
  AccuracyInspectedInsurances = "accuracyInspectedInsurances",
  ShowNppesDates = "showNppesDates",
  ShowAttestation = "showAttestation",
  HasZipSummaries = "hasZipSummaries",
  ShowNextClosestNetworkProviders = "showNextClosestNetworkProviders",
  TimeDistanceCalculatorTypeChange = "timeDistanceCalculatorTypeChange",
  ShowAccuracyGapAnalysis = "showAccuracyGapAnalysis",
  ShowMipsScore = "showMipsScore",
  MipsVersionId = "mipsVersionId",
  ShowCMSCredit = "showCMSCredit",
  ShowPciData = "showPciData",
  PcaVersionId = "pcaVersionId",
  ShowPciDashboard = "showPciDashboard",
  ShowLocationConfidenceScores = "showLocationConfidenceScores",
  LocationConfidenceScoresVersionId = "locationConfidenceScoresVersionId",
  ShowMotiveAppropriatenessScore = "showMotiveAppropriatenessScore",
  MotiveScoresVersionId = "motiveScoresVersionId",
  ValidNPIVersionId = "validNPIVersionId",
  UseProvidersForMarketAnalysis = "useProvidersForMarketAnalysis",
  IncludeInEnterpriseComplianceDashboard = "includeInEnterpriseComplianceDashboard",
  ZipAccessCodeMapSetId = "zipAccessCodeMapSetId",
  ZipAccessCodeMapSetVersionId = "zipAccessCodeMapSetVersionId",
  ExcludeAccuracyPractitionerAtLocationInspector = "excludeAccuracyPractitionerAtLocationInspector",
  ExcludeProviderClaimsActivityInspector = "excludeProviderClaimsActivityInspector",
  CalculateStandards = "calculateStandards",
  ShowNetworkIntegrityDashboard = "showNetworkIntegrityDashboard",
  ShowCareJourneyScores = "showCareJourneyScores",
  CareJourneyScoresVersionId = "careJourneyScoresVersionId",
  ShowAffiliationsInsights = "showAffiliationsInsights",
  DisplayOnNetworkAccordion = "displayOnNetworkAccordion"
}

/**
 * Translates enum value to user-friendly description
 * @param projectChangeReason
 */

function translateProjectChangeReason(projectChangeReason: ProjectChangeReason): string {
  switch (projectChangeReason) {
    case ProjectChangeReason.NoChange:
      return "No Changes Detected.";
    case ProjectChangeReason.ProviderExclusionsData:
      return "Deactivated / Excluded Provider Source Data Changed.";
    case ProjectChangeReason.TemplateCollectionId:
      return "Different Analysis Template Selected.";
    case ProjectChangeReason.TemplateCorrelationId:
      return "Analysis Template Correlation ID Changed.";
    case ProjectChangeReason.TemplateId:
      return "Analysis Template Version Changed.";
    case ProjectChangeReason.MemberSetId:
      return "Different Member Population Selected.";
    case ProjectChangeReason.MemberSetVersionId:
      return "Member Population Version Changed.";
    case ProjectChangeReason.NetworkProviderSetId:
      return "Different Provider Network Selected.";
    case ProjectChangeReason.NetworkProviderSetVersionId:
      return "Provider Network Version Changed.";
    case ProjectChangeReason.ProspectProviderSetId:
      return "Different Prospect Network Selected.";
    case ProjectChangeReason.ProspectProviderSetVersionId:
      return "Prospect Network Version Changed.";
    case ProjectChangeReason.MarketProviderSetId:
      return "Different Market Network Selected.";
    case ProjectChangeReason.MarketProviderSetVersionId:
      return "Market Network Version Changed.";
    case ProjectChangeReason.AccessCodeMapSetId:
      return "Different County Class Map Selected.";
    case ProjectChangeReason.AccessCodeMapSetVersionId:
      return "County Class Map Version Changed.";
    case ProjectChangeReason.NetworkSpecialtyCodeMapSetId:
      return "Different Provider Network Specialty Crosswalk Selected.";
    case ProjectChangeReason.NetworkSpecialtyCodeMapSetVersionId:
      return "Provider Network Specialty Crosswalk Version Changed.";
    case ProjectChangeReason.ProspectSpecialtyCodeMapSetId:
      return "Different Prospect Network Specialty Crosswalk Selected.";
    case ProjectChangeReason.ProspectSpecialtyCodeMapSetVersionId:
      return "Prospect Network Specialty Crosswalk Version Changed.";
    case ProjectChangeReason.MarketSpecialtyCodeMapSetId:
      return "Different Market Network Specialty Crosswalk Selected.";
    case ProjectChangeReason.MarketSpecialtyCodeMapSetVersionId:
      return "Market Network Specialty Crosswalk Version Changed.";
    case ProjectChangeReason.AttestationCrosswalkCodeMapSetId:
      return "Different Attestation Specialty Crosswalk Selected.";
    case ProjectChangeReason.AttestationCrosswalkCodeMapSetVersionId:
      return "Attestation Specialty Crosswalk Version Changed.";
    case ProjectChangeReason.ServiceAreaRegionSetId:
      return "Service Area Changed.";
    case ProjectChangeReason.ProviderExclusionsConfig:
      return "Provider Exclusions Settings Changed.";
    case ProjectChangeReason.ExcludedSpecialtyGroupCodes:
      return "Specialty Group Exclusions Changed.";
    case ProjectChangeReason.StrictTimeAndDistance:
      return "Strict Time And Distance Changed.";
    case ProjectChangeReason.CountyStatusUpdate:
      return "The status for one or more counties has changed.";
    case ProjectChangeReason.SpecialtyGroupNetworkProviderSetCodeMapSetId:
      return "Different Specialty Group to Network Provider Network Map Selected.";
    case ProjectChangeReason.SpecialtyGroupNetworkProviderSetCodeMapSetVersionId:
      return "Specialty Group to Network Provider Network Map Version Changed.";
    case ProjectChangeReason.MemberSetId2:
      return "Different Second Member Population Selected.";
    case ProjectChangeReason.MemberSetVersionId2:
      return "Second Member Population Version Changed.";
    case ProjectChangeReason.MemberSetAlias:
      return "Member Population Alias Changed.";
    case ProjectChangeReason.MemberSetAlias2:
      return "Second Member Population Alias Changed.";
    case ProjectChangeReason.MembershipRiskMemberSetId:
      return "Different Membership Risk Member Population Selected.";
    case ProjectChangeReason.MembershipRiskMemberSetVersionId:
      return "Membership Risk Member Population Version Changed.";
    case ProjectChangeReason.MembershipRiskMemberSetAlias:
      return "Membership Risk Member Population Alias Changed.";
    case ProjectChangeReason.AccuracyTemplateId:
      return "Accuracy Template Id Changed.";
    case ProjectChangeReason.AccuracyTemplateCollectionId:
      return "Accuracy Template Collection Id Changed.";
    case ProjectChangeReason.BoundMemberships:
      return "Memberships bound to specialty groups Changed.";
    case ProjectChangeReason.TelehealthSpecialtyGroupCodes:
      return "Telehealth Specialty Groups Changed.";
    case ProjectChangeReason.AccuracySpecialtyToBdxCodeMapSetId:
      return "Different Accuracy Specialty to BDX UID Crosswalk Selected.";
    case ProjectChangeReason.AccuracySpecialtyToBdxCodeMapSetVersionId:
      return "Accuracy Specialty to BDX UID Crosswalk Version Changed.";
    case ProjectChangeReason.AccuracyInspectedInsurances:
      return "Accuracy Inspected Insurances Changed.";
    case ProjectChangeReason.ShowNppesDates:
      return "Show NPPES Dates Changed.";
    case ProjectChangeReason.ShowAttestation:
      return "Show Attestation Changed.";
    case ProjectChangeReason.HasZipSummaries:
      return "Calculate Zip Summaries Selection Changed.";
    case ProjectChangeReason.ShowNextClosestNetworkProviders:
      return "Show Next Closest Network Providers Changed.";
    case ProjectChangeReason.TimeDistanceCalculatorTypeChange:
      return "Time/Distance Calculation Type Changed.";
    case ProjectChangeReason.ShowAccuracyGapAnalysis:
      return "Show Accuracy Gap Analysis Changed";
    case ProjectChangeReason.ShowMipsScore:
      return "Show MIPS Score Changed.";
    case ProjectChangeReason.MipsVersionId:
      return "Current MIPS Version on this project is out of date";
    case ProjectChangeReason.ShowCMSCredit:
      return "Apply CMS Credit Changed.";
    case ProjectChangeReason.ShowPciData:
      return "Show PCI Data Changed.";
    case ProjectChangeReason.PcaVersionId:
      return "Current Provider Claims Activity version on this project is out of date.";
    case ProjectChangeReason.ValidNPIVersionId:
      return "Valid Provider Source version on this project is out of date.";
    case ProjectChangeReason.ShowLocationConfidenceScores:
      return "Show Location Confidence Scores Changed.";
    case ProjectChangeReason.LocationConfidenceScoresVersionId:
      return "Current location confidence score version on this project is out of date";
    case ProjectChangeReason.UseProvidersForMarketAnalysis:
      return "'Use Providers for Market Analysis' Setting Changed.";
    case ProjectChangeReason.IncludeInEnterpriseComplianceDashboard:
      return "Include In Enterprise Compliance Dashboard Changed";
    case ProjectChangeReason.ShowPciDashboard:
      return "Show PCI Dashboard Changed.";
    case ProjectChangeReason.ShowMotiveAppropriatenessScore:
      return "Show Motive Appropriateness Score Changed.";
    case ProjectChangeReason.MotiveScoresVersionId:
      return "Current Motive score version on this project is out of date.";
    case ProjectChangeReason.ZipAccessCodeMapSetId:
      return "Different Zip Class Map Selected.";
    case ProjectChangeReason.ZipAccessCodeMapSetVersionId:
      return "Zip Class Map Version Changed.";
    case ProjectChangeReason.ExcludeAccuracyPractitionerAtLocationInspector:
      return "Accuracy Practitioner at Location Inspector option changed.";
    case ProjectChangeReason.ExcludeProviderClaimsActivityInspector:
      return "Accuracy Provider Claims Activity Inspector option changed.";
    case ProjectChangeReason.ShowNetworkIntegrityDashboard:
      return "Network Integrity Dashboard Enabled";
    case ProjectChangeReason.ShowCareJourneyScores:
      return "CareJourney Scores Changed.";
    case ProjectChangeReason.CareJourneyScoresVersionId:
      return "Current CareJourney Scores version on this project is out of date.";
    case ProjectChangeReason.ShowAffiliationsInsights:
      return "Show Affiliations Insights on this project has changed.";
      case ProjectChangeReason.DisplayOnNetworkAccordion:
      return "Display on Network Accordion on this project has changed.";
    default:
      throw new Error("Unexpected ProjectChangeReason: " + projectChangeReason);
  }
}

export {
  ProjectChangeReason, translateProjectChangeReason,
};
